import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useIframeMessageListener } from '../hooks/useIframeMessageListener';

const IframeRedirectListener = () => {
  const message = useIframeMessageListener('redirect');
  const history = useHistory();

  useEffect(() => {
    if (message?.url) {
      let redirectUrl = message.url;
      if (message.params) {
        const queryParams = new URLSearchParams(message.params).toString();
        redirectUrl += '?' + queryParams;
      }

      history.push(redirectUrl);
    }
  }, [message, history]);

  return null;
};

export default IframeRedirectListener;
